import React, { useState,useEffect } from "react";
import { Button, Divider } from "@mui/material";
import { display, Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { SideDrawer } from "../../atoms/Drawer/SideDrawer";
import { TextInput } from "../../atoms/Input/TextInput";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";


export const ViewSpecialtyDetails = ({ close, data, OpenDrawer }) => {

   const { control, reset } = useForm({
    defaultValues: {
      specialty: "",
      createdDate: "",
      createdBy: "",
    },
  });
  useEffect(() => {
    if (data) {
      reset({
        description: data.description || "",
        createdDate: data.createdOn
          ? new Date(data.createdOn).toLocaleDateString("en-GB", { timeZone: "Asia/Colombo" })
          : "",
        createdBy: data.email || "",
      });
    }
  }, [data, reset]);


  return (
    <SideDrawer
      headingText="View specialty"
      width="648px"
      openDrawer={OpenDrawer}
      close={close}
      anchorDrawer="right"
    >
      <div style={{ paddingBottom: "20px", marginTop: "20px" }}>
        <form>
          <Stack rowGap="20px" width="600px">
            <TextInput
              name="description"
              label="Specialty"
              control={control}
              fullWidth
              disabled
              color="#f3f2f8"
            />

            <TextInput
              name="createdDate"
              label="Created Date"
              control={control}
              fullWidth
              disabled
              color="#f3f2f8"
            />

            <TextInput
              name="createdBy"
              label="Created By"
              control={control}
              fullWidth
              disabled
              color="#f3f2f8"
            />

            <FormItemsWrap direction="row" justifyContent="flex-end" gap="16px">
              <Button variant="whiteSquare" onClick={close}>
                Cancel
              </Button>
            </FormItemsWrap>
          </Stack>
        </form>
      </div>
    </SideDrawer>
  );

  
};
export default ViewSpecialtyDetails;
